import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  contextError: {
    id: 'portal.components.courseMap.contextError',
    defaultMessage: 'ThirdLevelOutline must be used within a CourseSideItemProvider',
    description: 'Error message for missing CourseSideItemProvider context',
  },
});

export default messages;
